import { useContext } from 'react';

import { SearchInput } from '@hero/molecules';

import { TableFilter } from '../Filter';
import { TranslationContext } from '../translation/translationContext';

import { SecondHead } from './SecondHead';
import * as S from './style';

function Header({
  table,
  tableRef,
  components,
  globalFilters,
  filterOptions,
  setSearchTerm = () => {},
  onFilterChange,
  setGlobalFilters,
  enableSearch = true,
  enableFilter,
  filterProps,
  searchProps
}) {
  const translations = useContext(TranslationContext);

  return (
    <>
      <S.TableHeader>
        {enableFilter && (
          <TableFilter
            tableRef={tableRef}
            globalFilters={globalFilters}
            components={components}
            value={globalFilters?.filters || []}
            onFilterChange={onFilterChange}
            options={filterOptions}
            table={table}
            creatable={false}
            setGlobalFilters={setGlobalFilters}
            {...filterProps}
          />
        )}
        {enableSearch && (
          <S.TableHeaderInput>
            <SearchInput {...searchProps} onChange={setSearchTerm} />
          </S.TableHeaderInput>
        )}
      </S.TableHeader>
      <SecondHead
        table={table}
        components={components}
        globalFilters={globalFilters}
        filteredWithText={translations.filteredWithText}
        onFilterChange={onFilterChange}
      />
    </>
  );
}

Header.S = S;

export { Header };
